import './TheToolbarMenu.js';
import './types.js';
const styleSheet = new CSSStyleSheet();
styleSheet.replaceSync(`
  *, :host {
    box-sizing: border-box;
  }

  :host {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    width: 100%;
    height: 50px;
    z-index: 400;
    padding: 0 10px;
    border-bottom: 1px solid lightgrey;
    
    background-color: var(--color-toolbar);
  }
`);
export class TheToolbar extends HTMLElement {
    static tag = 'the-toolbar';
    constructor() {
        super();
        this.attachShadow({ mode: 'open' }).adoptedStyleSheets = [styleSheet];
    }
    connectedCallback() {
        this.shadowRoot.innerHTML = `
      <the-toolbar-menu></the-toolbar-menu>
    `;
    }
}
window.customElements.define(TheToolbar.tag, TheToolbar);
